import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Gift, Trophy, Star, Zap } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useToast } from '../hooks/use-toast';

const Rewards = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const rewards = [
    {
      title: 'Trading Volume Bonus',
      description: 'Trade $10,000 to earn 50 USDT',
      progress: 65,
      reward: '50 USDT',
      icon: Trophy,
      color: 'from-yellow-400 to-yellow-500'
    },
    {
      title: 'Daily Login Streak',
      description: '7 days login streak reward',
      progress: 40,
      reward: '25 USDT',
      icon: Star,
      color: 'from-purple-400 to-purple-500'
    },
    {
      title: 'Referral Milestone',
      description: 'Refer 10 friends',
      progress: 80,
      reward: '100 USDT',
      icon: Gift,
      color: 'from-green-400 to-green-500'
    },
  ];

  const claimedRewards = [
    { title: 'Welcome Bonus', amount: '10 USDT', date: '2025-01-01' },
    { title: 'First Trade', amount: '5 USDT', date: '2025-01-02' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      <div className="sticky top-0 bg-slate-900/95 backdrop-blur-sm border-b border-cyan-500/20 z-10">
        <div className="flex items-center justify-between px-4 py-4">
          <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-cyan-400 hover:text-cyan-300">
            <ArrowLeft className="w-5 h-5" />
            <span className="font-semibold">Back</span>
          </button>
          <h1 className="text-lg font-bold text-cyan-400">Rewards</h1>
          <div className="w-16"></div>
        </div>
      </div>

      <div className="px-4 py-6">
        {/* Total Rewards */}
        <div className="bg-gradient-to-r from-cyan-900/30 to-blue-900/30 border border-cyan-500/30 rounded-xl p-6 mb-6 neon-border">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-cyan-600 text-sm mb-1">Total Rewards Earned</div>
              <div className="text-3xl font-bold text-cyan-400">$190 USDT</div>
            </div>
            <Zap className="w-12 h-12 text-yellow-400" />
          </div>
        </div>

        {/* Active Rewards */}
        <div className="mb-6">
          <h2 className="text-lg font-bold text-cyan-400 mb-4">Active Challenges</h2>
          {rewards.map((reward, idx) => {
            const Icon = reward.icon;
            return (
              <div key={idx} className="bg-slate-800/50 border border-cyan-500/20 rounded-xl p-4 mb-3">
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${reward.color} flex items-center justify-center shadow-lg`}>
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <div className="flex-1">
                    <div className="font-semibold text-cyan-300">{reward.title}</div>
                    <div className="text-xs text-cyan-700">{reward.description}</div>
                  </div>
                  <div className="text-right">
                    <div className="font-bold text-green-400">{reward.reward}</div>
                  </div>
                </div>
                <div className="mb-2">
                  <div className="flex justify-between text-xs text-cyan-600 mb-1">
                    <span>Progress</span>
                    <span>{reward.progress}%</span>
                  </div>
                  <div className="w-full bg-slate-700 rounded-full h-2">
                    <div
                      className="bg-gradient-to-r from-cyan-500 to-blue-500 h-2 rounded-full transition-all"
                      style={{ width: `${reward.progress}%` }}
                    ></div>
                  </div>
                </div>
                {reward.progress === 100 && (
                  <Button
                    onClick={() => toast({ title: 'Claimed!', description: 'Reward has been added to your wallet' })}
                    className="w-full h-10 bg-green-500 hover:bg-green-600 text-white neon-button mt-2"
                  >
                    Claim Reward
                  </Button>
                )}
              </div>
            );
          })}
        </div>

        {/* Claimed Rewards History */}
        <div>
          <h2 className="text-lg font-bold text-cyan-400 mb-4">Claimed Rewards</h2>
          {claimedRewards.map((reward, idx) => (
            <div key={idx} className="bg-slate-800/50 border border-cyan-500/20 rounded-xl p-4 mb-3">
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-semibold text-cyan-300">{reward.title}</div>
                  <div className="text-xs text-cyan-700">{reward.date}</div>
                </div>
                <div className="font-semibold text-green-400">{reward.amount}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Rewards;